import { render } from "./westSoftCouponspayModel.vue?vue&type=template&id=0aed8d80"
import script from "./westSoftCouponspayModel.vue?vue&type=script&lang=js"
export * from "./westSoftCouponspayModel.vue?vue&type=script&lang=js"

import "./westSoftCouponspayModel.vue?vue&type=style&index=0&id=0aed8d80&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__